import { forwardRef, type HTMLAttributes, type ReactNode } from 'react'
import { cn } from '#app/utils/tailwind-merge.ts'

type UlProps = { children: ReactNode } & HTMLAttributes<HTMLUListElement>

const Ul = forwardRef<HTMLUListElement, UlProps>(({ className, ...props }, ref) => <ul ref={ref} className={cn('ml-space-10 list-disc', className)} {...props} />)
Ul.displayName = 'Ul'

export { Ul }
